import { Component, OnInit, Output, EventEmitter, Inject, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';
//import { AuthenticationService } from '../../core/services/auth.service';
import { AuthfakeauthenticationService } from '../../core/services/authfake.service';
import { environment } from '../../../environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2'
import { ApiserviceService } from 'src/app/core/services/apiservice.service';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss']
})

/**
 * Topbar component
 */
export class TopbarComponent implements OnInit {

  element: { mozFullScreenElement: any; webkitFullscreenElement: any; requestFullscreen: () => void; mozRequestFullScreen: () => void; webkitRequestFullscreen: () => void; msRequestFullscreen: () => void; } | undefined;
  cookieValue: string | undefined;
  flagvalue: string | undefined;
  countryName: string | undefined;
  valueset: any;
  yetkili_isim:string | undefined;
  mevcut:string | undefined;
  sifre:string | undefined;
  sifre_tekrar:string | undefined;
  user:any;
  birimadi:any;
  @ViewChild('sifre_modal') sifre_modal : any;
  
  constructor(@Inject(DOCUMENT) private document: any, private router: Router, 
              private authFackservice: AuthfakeauthenticationService,
              public _cookiesService: CookieService,private modalService: NgbModal,private api:ApiserviceService) {
  }

 



  @Output() settingsButtonClicked = new EventEmitter();
  @Output() mobileMenuButtonClicked = new EventEmitter();

  ngOnInit() {

    
    const kullaniciData = sessionStorage.getItem('kullanici');
    this.user = kullaniciData ? JSON.parse(kullaniciData) : null;
  
    if (this.user) {
      this.yetkili_isim=this.user.data.name+" "+this.user.data.surname;

    }


  }

 

  setLanguage(text: string, lang: string, flag: string) {
    this.countryName = text;
    this.flagvalue = flag;
    this.cookieValue = lang;
    
  }

  /**
   * Toggles the right sidebar
   */
  toggleRightSidebar() {
    this.settingsButtonClicked.emit();
  }

  /**
   * Toggle the menu bar when having mobile screen
   */
  toggleMobileMenu(event: any) {
    event.preventDefault();
    this.mobileMenuButtonClicked.emit();
  }

  /**
   * Logout the user
   */
  logout() {
   
    this.authFackservice.logout();
    this.router.navigate(['account/login']);
  }

  sifremodal(){
    this.modalService.open(this.sifre_modal, { size: 's', centered: true });
  }

  sifre_degistir(){
  
      if(this.sifre && this.sifre_tekrar && this.sifre.length>7 && this.sifre_tekrar.length>7){
        if(this.sifre==this.sifre_tekrar ){
          
          

          Swal.fire({
            title: 'Şifreniz Değiştirilecek Onaylıyor musunuz?',
            text: "Onaylıyor musun?",
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText:'İptal',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Evet'
          }).then((result) => {
            if (result.isConfirmed) {
              const sifre={
                id:this.user.data.id,
                password:this.sifre
              }
              
              this.api.post('user/update_password', sifre).then((datas) => {
                
                Swal.fire(
                  {
                    title: 'Başarılı',
                     text: "Şifreniz Başarılı Bir Şekilde Değiştirilmiştir.",
                     icon: 'success',
                     confirmButtonText: 'Tamam'
                  }
                )
                this.modalService.dismissAll();
                this.logout();
              });
            }
          });
        }else{
          Swal.fire(
            {
              title: 'Hata',
               text: "Yeni Şifreniz ve Şifre Tekrarı Aynı Değil",
               icon: 'error',
               confirmButtonText: 'Tamam'
            }
          )
        }
      }else{
        Swal.fire(
          {
            title: 'Hata',
             text: "Şifreniz En Az 8 Karakter Olmalı",
             icon: 'error',
             confirmButtonText: 'Tamam'
          }
        )
      }

  }

  /**
   * Fullscreen method
   */
 
}
